import PropTypes from "prop-types"
import React, {PureComponent} from "react"

import platformTracking from "@irati-tracking/platform"
import checkoutService from "@irati/checkout/services/checkout"
import id from "@irati/utils/id"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"

import Flex from "@irati/ui/src/Flex"
import Loading from "@irati/ui/src/Loading"
import mainTheme from "@irati/ui/src/global/theme"
import SecondaryDetailsItem from "../Item"
import Wrapper from "../Wrapper"
import {StyledIconText, StyledRouterLink} from "./styled"

interface Data {
  amount: number,
  redemptionUuid?: string,
  orderTotal?: SpendStatementItemTransferOrderTotal
}

interface Props extends InjectIntl {
  className?: string,
  id?: string,
  data: Data
}

interface State {
  load?: Promise<any>,
  redemptionId?: string
}
class Cashback extends PureComponent<Props> {
  state: State = {}

  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  getRedemptionId = async() => {
    const {redemptionUuid} = this.props.data
    const checkout = await checkoutService.getCheckout(redemptionUuid!)
    const {fullRedemptions} = checkout
    const [{uuid}] = fullRedemptions

    this.setState({redemptionId: uuid})
  }

  componentDidMount(): void {
    const promise = this.getRedemptionId()
    this.setState({load: promise})
  }

  render() {
    const {className, data} = this.props
    const {apps} = this.context
    const {orderTotal, amount} = data
    const idNamespace = id("secondary-details-spend", this.props)

    let orderTotalText
    if (orderTotal) {
      const {value, currency} = orderTotal
      if (value && currency) {
        orderTotalText = (
          currency !== "TT"
            ? <FormattedMessage
              id="wallet.secondaryDetails.spend.orderTotal"
              values={{
                amount: this.props.intl.formatNumber(value, {style: "currency", currency})
              }} />
            : <FormattedMessage
              id="wallet.secondaryDetails.spend.flexiPoints"
              values={{
                amount: this.props.intl.formatNumber(amount, {style: "currency", currency})
              }} />
        )
      }
    }

    return (
      <Wrapper className={className} id={idNamespace}>
        {orderTotalText && <SecondaryDetailsItem isFirstItem text={orderTotalText} />}
        <Flex marginLeft="auto" marginRight={this.state.redemptionId ? "0" : mainTheme.spacing.four}>
          <Loading load={this.state.load} initLoad>
            <StyledRouterLink
              app={apps.PERKS}
              onClick={() => platformTracking.click("order_history", {source: "wallet_transaction"})}
              to={`/account/my-perks/new?redemptionUuid=${this.state.redemptionId}`}
              id={id("my-perks-button", idNamespace)}
              uppercase={false}>
              <StyledIconText
                icon="angleRight"
                iconPosition="right">
                <FormattedMessage id="wallet.secondaryDetails.spend.myPerksButtonText" />
              </StyledIconText>
            </StyledRouterLink>
          </Loading>
        </Flex>

      </Wrapper>
    )
  }
}

export default injectIntl(Cashback)
